import { DataSetKey, ViewConfig } from "../../model/core/Workbook";

// /////////////////////////////
// // Register view
export const viewType = "tree";

export interface TreeViewConfig extends ViewConfig {
  datasetId?: DataSetKey;
  nameColumnId?: PropertyKey;
  hierarchyDatasetId: DataSetKey;
}
